<template>
  <div class="widget faq">
    <div class="widget-heading align-items-center">
      <h2 class="textStyle">
        {{ $tc("admin.trainingCourse.title", 2) }}
        <span v-if="isFiltered && currentTab === 'registration'">{{
          $tc("global.data_table.filtered_result", registrationCount, registrationCount >= 1 ? 1 : 2)
        }}</span>
      </h2>
      <div v-module="{ code: moduleConstantes.MODULE_STUDEA_REGISTRATION }" class="d-flex flex-column flex-md-row">
        <button
          v-for="tab in tabs"
          :key="tab.code"
          :class="'tab ' + (tab.code === currentTab ? 'active' : '')"
          @click="toggleActiveTab(tab.code)"
        >
          {{ tab.title }}
          <span v-if="tab.code === 'registration' && registrationCount >= 1" class="tab__count">{{
            registrationCount
          }}</span>
        </button>
        <MagnifyingGlassComponent
          v-if="currentTab === 'registration'"
          class="ms-3"
          :isFiltered="isFiltered"
          @openSearch="openSearch"
          @resetSearch="resetSearch"
        />
      </div>
    </div>
    <div class="widget-content faq-layouting position-relative">
      <TrainingTrainingCourseComponent
        v-if="currentTab === 'group'"
        :training="training"
        :currentTrainingCourse="currentTrainingCourse"
        :emptyLabel="$t('registration.empty_registation_list')"
        :loading="groupLoading"
        @createRegistration="createRegistration"
        @deleteGroup="deleteGroup"
      />
      <DataTableComponent
        v-else-if="currentTab === 'registration'"
        :rowList="registrationList"
        :columns="registrationColumns"
        :actions="registrationActions"
        :count="registrationCount"
        :loading="groupLoading"
        :limit="registrationLimit"
        :showSearch="true"
        @refresh="refresh"
      />
    </div>
  </div>
</template>

<script>
import DataTableComponent from "@/components/data-table/DataTableComponent.vue";
import { i18n } from "@/i18n";
import { moduleManager } from "@/services/module/module-manager";
import { moduleConstantes } from "@/constantes/module";
import TrainingTrainingCourseComponent from "@/components/training/TrainingTrainingCourseComponent.vue";
import MagnifyingGlassComponent from "@/components/utilities/MagnifyingGlassComponent.vue";

export default {
  name: "TrainingBlockComponent",
  components: { MagnifyingGlassComponent, TrainingTrainingCourseComponent, DataTableComponent },
  props: {
    training: {
      type: Object,
      required: true,
    },
    registrationLoading: {
      type: Boolean,
      required: true,
    },
    groupLoading: {
      type: Boolean,
      required: true,
    },
    registrationList: {
      type: Object,
      required: true,
    },
    registrationColumns: {
      type: Object,
      required: true,
    },
    registrationCount: {
      type: Number,
      required: true,
    },
    registrationLimit: {
      type: Number,
      required: true,
    },
    isFiltered: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["createRegistration", "refresh", "openSearch", "resetSearch", "deleteGroup"],
  data() {
    return {
      currentTab: "group",
      registrationActions: [
        {
          action: "TrainingPreRegistration",
          actionParams: [
            { title: "registration", code: "crypted_id" },
            { title: "group", code: "group_crypted_id" },
            { title: "tab", data: 1 },
          ],
          type: "router",
          icon: "eye",
          tooltip: this.$t("registration.group_action.see_sheet"),
          className: "success",
        },
      ],
    };
  },
  computed: {
    currentTrainingCourse() {
      return this.training &&
        this.training.activeTrainingCourses &&
        Object.keys(this.training.activeTrainingCourses).length
        ? Object.values(this.training.activeTrainingCourses)[0]
        : null;
    },

    tabs() {
      const tabs = [{ code: "group", title: i18n.global.tc("studea_manager.group.title", 2) }];
      if (moduleManager.isModuleActive(moduleConstantes.MODULE_STUDEA_REGISTRATION)) {
        tabs.push({ code: "registration", title: i18n.global.t("dashboard.registration") });
      }
      return tabs;
    },

    moduleConstantes() {
      return moduleConstantes;
    },
  },
  methods: {
    createRegistration(groupCryptedId) {
      this.$emit("createRegistration", groupCryptedId);
    },

    toggleActiveTab(code) {
      this.currentTab = code;
    },
    refresh(payload) {
      this.$emit("refresh", payload);
    },
    openSearch() {
      this.$emit("openSearch");
    },
    resetSearch() {
      this.$emit("resetSearch");
    },
    deleteGroup(cryptedId) {
      this.$emit("deleteGroup", cryptedId);
    },
  },
};
</script>

<style lang="scss" scoped>
.tab {
  position: relative;
  border-radius: 6px;
  color: var(--secondary-color);
  background-color: #f1f2f3;
  border: none;
  padding: 10px 15px;
  height: 45px;

  @include up-to-md {
    width: 100%;
  }

  &:hover,
  &.active {
    color: #f1f2f3;
    background: var(--secondary-color);
  }

  &__count {
    position: absolute;
    top: -5px;
    right: -10px;
    background-color: $green;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
    color: $white;
  }
}

.tab + .tab {
  margin-left: 10px;
  @include up-to-md {
    margin-left: 0;
    margin-top: 10px;
  }
}

.widget-heading {
  align-items: center;
  @include up-to-md {
    align-items: flex-start;
    flex-direction: column;
    gap: 15px;
  }
}

.button__container {
  @include up-to-md {
    width: 100%;
  }
}
</style>
